// extracted by mini-css-extract-plugin
export var root = "_6dZn";
export var rootCol = "itu8";
export var rootContainer = "TcQy";
export var rootGrid = "KE0s";
export var rootHeading = "N8EA";
export var rootItem = "ltZ1";
export var rootItemHeading = "c58D";
export var rootItemImage = "CJpz";
export var rootItemLink = "+V3T";
export var rootItemPicture = "jzYi";